/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Sharp_Pike_LeadInputs */

const en_slim_sharp_pike_lead = /** @type {(inputs: Slim_Sharp_Pike_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments can be assigned topics from this group alongside topics from other groups. When off, topics within the same group are mutually exclusive — a comment gets at most one topic from this group.`)
};

const de_slim_sharp_pike_lead = /** @type {(inputs: Slim_Sharp_Pike_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare können Themen aus dieser Gruppe zusammen mit Themen anderer Gruppen zugewiesen werden. Wenn deaktiviert, sind Themen innerhalb derselben Gruppe exklusiv — ein Kommentar erhält höchstens ein Thema aus dieser Gruppe.`)
};

/**
* | output |
* | --- |
* | "Comments can be assigned topics from this group alongside topics from other groups. When off, topics within the same group are mutually exclusive — a comment..." |
*
* @param {Slim_Sharp_Pike_LeadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_sharp_pike_lead = /** @type {((inputs?: Slim_Sharp_Pike_LeadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Sharp_Pike_LeadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_sharp_pike_lead(inputs)
	return de_slim_sharp_pike_lead(inputs)
});